module.exports = __webpack_public_path__ + "6635b78fe978ea6d8a03df92cbd73617.png";